import axios from 'axios';
import store from '@/store';

export default {
  index({
    preUrl,
    url = null,
    parentName = null,
    parentId = null,
    modelName,
    params,
    pagination = false,
    cancelTokenSource = null,
  }) {
    let _url = '';
    if (url) {
      _url = `/${url}`;
    } else {
      if (preUrl) {
        _url += `${preUrl}`;
      }
      if (parentName) {
        if (!parentId) return Promise.reject(new Error('id is required'));
        _url += `/${parentName}/${parentId}`;
      }
      if (modelName) {
        _url += `/${modelName}`;
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(_url, {
          params: {
            factory: store.state.app.factoryId,
            ...axios.defaults.params,
            ...params
          },
          cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
        })
        .then((res) => {
          if (pagination) {
            resolve(res.data);
          } else {
            resolve(res.data.data);
          }
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            console.log('Request canceled', err.message);
          } else {
            this.setErrorMessage(err);
            reject(err?.response?.data?.message || err?.message || err);
          }
        });
    });
  },
  show({ url = null, modelName = null, modelId = null, params, cancelTokenSource = null, }) {
    let _url = '';
    if (url) {
      _url = `/${url}`;
    } else if (modelName && modelId) {
      _url = `/${modelName}/${modelId}`;
    } else {
      return Promise.reject(new Error('url or modelName and modelId is required'));
    }
    return new Promise((resolve, reject) => {
      axios
        .get(_url, {
          params: {
            factory: store.state.app.factoryId,
            ...axios.defaults.params,
            ...params,
          },
          cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
        })
        .then((res) => {
          if (res.data.data) resolve(res.data.data);
          else if (res.data) resolve(res.data);
          else resolve(res);
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            console.log('Request canceled', err.message);
          } else {
            this.setErrorMessage(err);
            reject(err?.response?.data?.message || err?.message || err);
          }
        });
    });
  },
  delete({ url = null, modelName, modelId, params }) {
    let _url = '';
    if (url) {
      _url = `/${url}`;
    } else if (modelName && modelId) {
      _url = `/${modelName}/${modelId}`;
    } else {
      return Promise.reject(new Error('url or modelName and modelId is required'));
    }
    return new Promise((resolve, reject) => {
      axios
        .delete(_url, {
          params: {
            factory: store.state.app.factoryId,
            ...params,
          },
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          this.setErrorMessage(err);
          reject(err?.response?.data?.message || err?.message || err);
        });
    });
  },
  create({
    url = null,
    parentName = null,
    parentId = null,
    modelName = null,
    data,
    headers = null,
  }) {
    let _url = '';
    if (url) {
      _url = `/${url}`;
    } else {
      if (parentName) {
        if (!parentId || !modelName) return Promise.reject(new Error('id and modelName is required'));
        _url = `/${parentName}/${parentId}/${modelName}`;
      } else {
        _url = `/${modelName}`;
      }
    }
    const config = headers ? { headers } : undefined;
    return new Promise((resolve, reject) => {
      axios
        .post(_url, data, config)
        .then((res) => {
          resolve(res.data.data ? res.data.data : res.data);
        })
        .catch((err) => {
          this.setErrorMessage(err);
          reject(err?.response?.data?.message || err?.message || err);
        });
    });
  },
  update({
    url = null,
    parentName = null,
    parentId = null,
    modelName = null,
    modelId = null,
    data,
  }) {
    let _url = '';
    if (url) {
      _url = `/${url}`;
    } else {
      if (parentName) {
        if (!parentId || !modelName) return Promise.reject(new Error('id and modelName is required'));
        _url = `/${parentName}/${parentId}/${modelName}`;
      } else {
        _url = `/${modelName}/${modelId}`;
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .patch(_url, data)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          this.setErrorMessage(err);
          reject(err?.response?.data?.message || err?.message || err);
        });
    });
  },
  put({
    url = null,
    parentName = null,
    parentId = null,
    modelName = null,
    modelId = null,
    data,
  }) {
    let _url = '';
    if (url) {
      _url = `/${url}`;
    } else {
      if (parentName) {
        if (!parentId || !modelName) return Promise.reject(new Error('id and modelName is required'));
        _url = `/${parentName}/${parentId}/${modelName}`;
      } else {
        _url = `/${modelName}/${modelId}`;
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .put(_url, data)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          this.setErrorMessage(err);
          reject(err?.response?.data?.message || err?.message || err);
        });
    });
  },
  createAll({ parentName = null, parentId = null, modelName, datas }) {
    let url = '';
    if (parentName) {
      if (!parentId || !modelName) return Promise.reject(new Error('id and modelName is required'));
      url = `/${parentName}/${parentId}/${modelName}`;
    } else {
      url = `/${modelName}`;
    }
    const axiosTask = [];
    datas.forEach((data) => {
      axiosTask.push(axios.post(url, data));
    });
    return new Promise((resolve, reject) => {
      Promise.allSettled(axiosTask)
        .then((results) => {
          resolve(results);
        })
        .catch((err) => {
          this.setErrorMessage(err);
          reject(err?.response?.data?.message || err?.message || err);
        });
    });
  },
  updateAll({ parentName = null, parentId = null, modelName, datas }) {
    const axiosTask = [];
    datas.forEach((data) => {
      let url = '';
      if (parentName) {
        if (!parentId || !modelName) return Promise.reject(new Error('id and modelName is required'));
        url = `/${parentName}/${parentId}/${modelName}`;
      } else {
        url = `/${modelName}/${data.id}`;
      }
      axiosTask.push(axios.patch(url, data));
    });
    return new Promise((resolve, reject) => {
      Promise.allSettled(axiosTask)
        .then((results) => {
          resolve(results);
        })
        .catch((err) => {
          this.setErrorMessage(err);
          reject(err?.response?.data?.message || err?.message || err);
        });
    });
  },
  showAll({ modelName, datas }) {
    const axiosTask = [];
    if (!modelName) return Promise.reject(new Error('modelName is required'));
    datas.forEach((data) => {
      if (!data.id) return Promise.reject(new Error('id is required'));
      let url = `/${modelName}/${data.id}`;
      axiosTask.push(axios.get(url));
    });
    return new Promise((resolve, reject) => {
      Promise.allSettled(axiosTask)
        .then((results) => {
          resolve(results);
        })
        .catch((err) => {
          this.setErrorMessage(err);
          reject(err?.response?.data?.message || err?.message || err);
        });
    });
  },
  indexAll({ parentName = null, parentId = null, modelName, datas }) {
    const axiosTask = [];
    datas.forEach((data) => {
      let url = '';
      if (parentName) {
        if (!parentId || !modelName) return Promise.reject(new Error('id and modelName is required'));
        url = `/${parentName}/${parentId}/${modelName}`;
      } else {
        url = `/${modelName}`;
      }
      axiosTask.push(
        axios.get(url, {
          params: {
            factory: store.state.app.factoryId,
            ...axios.defaults.params,
            ...data.params,
          },
        }),
      );
    });
    return new Promise((resolve, reject) => {
      Promise.allSettled(axiosTask)
        .then((results) => {
          resolve(results);
        })
        .catch((err) => {
          this.setErrorMessage(err);
          reject(err?.response?.data?.message || err?.message || err);
        });
    });
  },
  setErrorMessage(err) {
    const errorMessage = err?.response?.data?.message || err?.message || err;
    if (
      errorMessage === 'no data.' ||
      errorMessage === 'invalid scopes' ||
      errorMessage === 'Too Many Attempts.'||
      errorMessage === 'has related data.' ||
      errorMessage === 'File not found.' ||
      errorMessage === 'delete error.'
    ) {
      store.dispatch('error/setErrorMessage', errorMessage);
      store.dispatch('error/setErrorTrue');
    } else {
      console.error(err);
    }
  },
};
